import { call, put, takeLatest } from "redux-saga/effects";
import * as apiCall from "../../../helpers/backend_helper";
import * as actionType from "./actionType";
import * as action from "./action";


// GET LIST
function* getMappingMasterListGenFunc() {
    try {
        const response = yield call(apiCall.MappingMasterGetAPI);
        yield put(action.getMappingMasterListSuccess(response.Data));
    } catch (error) {
        yield put(action.mappingMasterApiError());
    }
}


// SAVE
function* saveMappingMasterGenFunc({ config }) {
    try {
        const response = yield call(apiCall.MappingMasterPostAPI, config);
        yield put(action.saveMappingMasterSuccess(response));
    } catch (error) {
        yield put(action.mappingMasterApiError());
    }
}


function* MappingMasterSaga() {
    yield takeLatest(actionType.GET_MAPPING_MASTER_LIST,getMappingMasterListGenFunc);
    yield takeLatest(actionType.SAVE_MAPPING_MASTER,saveMappingMasterGenFunc);
}

export default MappingMasterSaga;